import { useState, useEffect } from 'react';

export default function usePersistState(key, defaultValue) {
  const [state, setState] = useState(() => {
    const value = window.sessionStorage.getItem(key);
    return value ? JSON.parse(value) : defaultValue;
  });

  useEffect(() => {
    window.sessionStorage.setItem(key, JSON.stringify(state));
  }, [key, state]);

  return [state, setState];
}